import React, { useState } from 'react';
import { Navigation, Tab } from './components/Navigation';
import { Dashboard } from './pages/Dashboard';
import { StorageZones } from './pages/StorageZones';
import { AddItem } from './pages/AddItem';
import { ItemDetail } from './pages/ItemDetail';
import { SearchItems } from './pages/SearchItems';
import { PullList } from './pages/PullList';
import { ExpiringItems } from './pages/ExpiringItems';
import { InventoryItem, useInventory } from './hooks/useInventory';
export function App() {
  const [currentTab, setCurrentTab] = useState<Tab>('dashboard');
  const [currentPage, setCurrentPage] = useState<string>('dashboard');
  const [selectedItem, setSelectedItem] = useState<InventoryItem | null>(null);
  const {
    addItem
  } = useInventory();
  const handleTabChange = (tab: Tab) => {
    if (tab === 'settings') {
      // Settings tab now goes to shopping list (Requisition Scroll)
      setCurrentPage('pull-list');
      setCurrentTab('settings');
    } else {
      setCurrentTab(tab);
      setCurrentPage(tab);
    }
    setSelectedItem(null);
  };
  const handleNavigate = (page: string) => {
    setCurrentPage(page);
    if (['zones', 'add'].includes(page)) {
      setCurrentTab(page as Tab);
    }
  };
  const handleItemClick = (item: InventoryItem) => {
    setSelectedItem(item);
  };
  const handleAddItem = (data: any) => {
    addItem({
      ...data,
      expiryDate: data.expiryDate || '2026-01-01',
      photoUrl: ''
    });
    handleNavigate('dashboard');
  };
  return <div className="min-h-screen bg-[#F5F0E1] text-[#2C2C2C] font-sans selection:bg-[#C9A227] selection:text-white" data-id="element-0">
      <main className="min-h-screen pb-20" data-id="element-1">
        {selectedItem ? <ItemDetail item={selectedItem} onBack={() => setSelectedItem(null)} data-id="element-2" /> : <>
            {currentTab === 'dashboard' && currentPage === 'dashboard' && <Dashboard onNavigate={handleNavigate} onMuffliato={() => {}} onGenerateTag={() => {}} data-id="element-3" />}

            {currentPage === 'search' && <SearchItems onBack={() => handleNavigate('dashboard')} onItemClick={handleItemClick} data-id="element-4" />}

            {currentPage === 'pull-list' && <PullList onBack={() => handleNavigate('dashboard')} data-id="element-5" />}

            {currentPage === 'expiring' && <ExpiringItems onBack={() => handleNavigate('dashboard')} onItemClick={handleItemClick} data-id="element-6" />}

            {(currentTab === 'zones' || currentPage === 'zones') && <StorageZones onBack={() => handleNavigate('dashboard')} onItemClick={handleItemClick} data-id="element-7" />}

            {(currentTab === 'add' || currentPage === 'add') && <AddItem onAdd={handleAddItem} onCancel={() => handleNavigate('dashboard')} data-id="element-8" />}
          </>}
      </main>

      {!selectedItem && <Navigation activeTab={currentTab} onTabChange={handleTabChange} data-id="element-9" />}
    </div>;
}